import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import Tabs from "../components/tabs/Tabs";
import LoginForm from "./LoginForm";
import "./LoginModal.scss";
import SignupForm from "./SignupForm";
import { useTranslation } from "react-i18next";
import { icAsset } from "../components/image/image-src";

interface AuthModalProps {
  isOpen: boolean;
  onClose: () => void;
  onLogin: (username: string, password: string) => void;
  onSignup: (username: string, password: string) => void;
}

const AuthModal: React.FC<AuthModalProps> = ({
  isOpen,
  onClose,
  onLogin,
  onSignup,
}) => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState(0);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isOpen]);
  const tabs = [
    {
      label: t("Sign in"),
      content: (
        <LoginForm
          onSubmit={(username: string, password: string) => {
            onLogin?.(username, password);
          }}
        />
      ),
    },
    {
      label: t("Sign up"),
      content: (
        <SignupForm
          onSubmit={() => {
            setActiveTab(0);
          }}
        />
      ),
    },
  ];

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel="Calendar Modal"
      className="auth-modal max-w-[calc(100%_-_24px)] px-4 py-6 sm:w-[34rem] sm:p-8"
      overlayClassName="overlay flex overflow-auto max-h-dvh"
    >
      <span
        className="close absolute right-[0.875rem] top-[0.875rem]"
        onClick={onClose}
      >
        <img
          className="close-icon"
          src={icAsset("../assets/images/icons/close.svg")}
          alt="close"
        />
      </span>
      <Tabs
        headerProps={{ style: { width: "16.5rem" } }}
        tabs={tabs}
        activeTab={activeTab}
        onTabChange={setActiveTab}
      />
    </Modal>
  );
};

export default AuthModal;
